export {FormModalHOC} from './FormModalComponent';
export {FormModalContainerHOC} from './FormModalContainer';

export {CreateFormModalContainerHOC} from './CreateFormModalContainer';
export {UpdateFormModalContainerHOC} from './UpdateFormModalContainer';

export const modalOptions = {
  isLegacy: true,
  modalProps: {
    useScrollWrapper: false,
  },
};



// WEBPACK FOOTER //
// ./src/js/components/modals/FormModal/index.js